import React from "react";
import Fallback from "../../components/Fallback";

const LiveChat = React.lazy(() => import("./pages/LiveChat"));
export const LiveChatScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <LiveChat {...props} />
  </React.Suspense>
);
